<template>
  <div class="di-icon-upload">
    <el-upload class="icon-uploader"
               :action="action"
               :cathUrl="uploadUrl"
               :show-file-list="false"
               :on-success="handleSuccess"
               :headers="upLoadHeader"
               :before-upload="beforeUpload">
      <img v-if="value" :src="value" class="image" @click="chageSign()">
      <template v-else>
        <i class="el-icon-plus icon-add" @click="chageSign()"></i>
        <span class="text" @click="chageSign()">点击选择</span>
      </template>
    </el-upload>
  </div>
</template>

<script>
import md5 from 'js-md5'

export default {
  name: 'icon-upload',
  props: {
    value: String,
    uploadUrl: String,
  },
  data () {
    return {
      action: '',
      upLoadHeader: {}
    }
  },
  methods: {
    handleSuccess (res, file) {
      this.$emit('input', res.data[0])
    },
    beforeUpload (file) {
    },
    chageSign () {
      let timestamp = new Date().getTime()
      this.action = this.uploadUrl + '&timestamp=' + timestamp
      let mainUrl = this.uploadUrl
      let pUrl = mainUrl.split('/ecard')[1].split('?')[0]
      let allowToken = `url=/ecard${pUrl}&timestamp=${timestamp}&key=WLXXPBDBVDZYONRQW7P9XRTJFI1NXCKA`
      let accessToken = md5(allowToken)
      this.upLoadHeader = {
        'sign': accessToken
      }
    }
  },
}
</script>

<style lang="less">
  @import "../../../common/styles/fun_var";

  .di-icon-upload {
    width: 70%;
    margin-bottom: 8px;
    display: inline-block;
    .el-upload {
      width: 64px;
      height: 64px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      &:hover {
        border-color: #409EFF;
      }
    }
    .icon-add {
      font-size: 24px;
      color: #8c939d;
      width: 64px;
      text-align: center;
      margin-top: 4px;
    }
    .text {
      width: 64px;
      text-align: center;
      font-size: 12px;
      margin-top: 8px;
      color: @text-color-blue-gray;
    }
    .image {
      width: 64px;
      height: 64px;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/di-ding/common/icon-upload.vue